'use client'

import { motion } from 'framer-motion'
import { useSearchParams } from '@/lib/hooks'
import { cn } from '@/lib/utils'

interface CartLayoutProps extends React.ComponentPropsWithoutRef<'div'> {}

export const CartLayout = ({ children, className }: CartLayoutProps) => {
  const { isCheckout, showMobileCart } = useSearchParams()

  return (
    <motion.div
      key="cart-layout"
      className={cn(
        'flex min-h-[calc(var(--inner-layout-height))] gap-6 will-change-transform lg:h-[calc(var(--inner-layout-height))]',
        {
          'lg:-translate-x-[calc(var(--cart-products-layout-width)+24px)]':
            isCheckout && !showMobileCart,
        },
        className,
      )}
    >
      {children}
    </motion.div>
  )
}
